import {contentManager} from '../../../../api/contentManager';
import { actionTypes } from '../../../constants/actionTypes';

import VttFooter from '../../../../api/footerEntity';
import { httpCallStartAction } from '../../../../middlewares/http/actions';

export const fetchFooterAction = () => (dispatch: any) => {
  dispatch(httpCallStartAction());

  contentManager.fetchFooterAsync()
    .then((footer) => {
      dispatch(fetchFooterCompleted(footer));
    })
    .catch(error => dispatch(handleError(error)));
};

const fetchFooterCompleted = (footer: VttFooter) => ({
  meta: {
    httpEnd: true,
  },
  payload: footer,
  type: actionTypes.FETCH_FOOTER_COMPLETED
});

const handleError = (reason: any) => ({
    meta: {
        httpEnd: true,
      },
    payload: {message: reason.message, hasError: true},
    type: actionTypes.FETCH_CONTENT_PAGE_ERROR
  });


// WEBPACK FOOTER //
// ./src/common/components/footer/actions/fetchFooter.ts